import { Box, Stack, styled } from '@mui/material';
import { colors } from '@watter/shared-components';

export const focuseEffect = () => ({
    content: "''",
    background:
        'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: -1,
    inset: 0,
    borderRadius: '28px',
    transform: 'scale(1.02, 1.06)',
});

const getIconFill = (theme: any) => (theme.palette.mode === 'dark' ? colors.white : colors.blackColor);
const getTextColor = (theme: any) => (theme.palette.mode === 'dark' ? colors.info : colors.gray);
const getFieldSetColor = (theme: any) => (theme.palette.mode === 'dark' ? colors.lightHead : colors.lightGray);
const getButtonShadow = (theme: any) =>
    theme.palette.mode === 'dark'
        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040';
export const MainWrapper = styled(Box)(({ theme }) => ({
    background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.white,
    boxShadow: '0px 0px 30px 0px #0000001A',
    padding: theme.spacing(5),
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: theme.spacing(3),
    height: 'calc(100dvh - 160px)',
    overflow: 'auto',
    rowGap: theme.spacing(2.5),
    '& form': {
        display: 'grid',
        gridTemplateColumns: '1fr 35%',
        gap: theme.spacing(3),
        zIndex: 0,
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column-reverse',
            gap: theme.spacing(1),
        },
    },
    '& .details': {
        '& .MuiTypography-subtitle1': {
            fontFamily: 'good_sansregular',
            color: getTextColor(theme),
        },
        '& input,.MuiSelect-select ': {
            padding: theme.spacing(1.0625, 0),
            textOverflow: 'ellipsis',
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root, .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0 0 1px 0',
                borderRadius: 0,
                borderColor: colors.lightGray,
            },
        },
        '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiInputBase-input': {
                color: getIconFill(theme),
                '-webkit-text-fill-color': 'inherit',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        '& .header': {
            fontFamily: 'good_sansbold',
        },
        '&.profileDetails': {
            '& .MuiFormControl-root': {
                marginBottom: theme.spacing(0),
            },
            '& .MuiGrid2-root': {
                '& .MuiStack-root': {
                    position: 'relative',
                    '& .MuiFormHelperText-root': {
                        position: 'absolute',
                        bottom: theme.spacing(-2.5),
                    },
                },
            },
        },
        '& .cstVerify': {
            position: 'relative',
            '& .MuiButton-root': {
                position: 'absolute',
                right: theme.spacing(0),
                top: theme.spacing(3.5),
                fontSize: theme.spacing(1.5),
                letterSpacing: 0,
                '&.verify': {
                    background: colors.errorRedBg,
                    color: colors.errorTextBtn,
                },
                '&.verified': {
                    background: colors.verifyBg,
                    color: colors.verifyText,
                },
            },
            '&.cstMobileNumber': {
                '& .MuiSelect-select': {
                    textOverflow: 'inherit',
                },
            },
        },
        '& .cstEmail': {
            '& .cstDisableEmail': {
                '& .MuiInputBase-root.Mui-disabled': {
                    '& .MuiInputBase-input': {
                        color: 'gray',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderBottom: `1px solid ${colors.lightGray}`,
                    },
                },
            },
        },
    },

    '& .actionFooter': {
        '& .cstBtn': {
            boxShadow: getButtonShadow(theme),
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
            color: getIconFill(theme),
            fontSize: theme.spacing(1.75),
            padding: theme.spacing(1.5, 2),
            fontFamily: 'good_sansmedium',
            minWidth: theme.spacing(17.5),
            whiteSpace: 'nowrap',
            position: 'relative',
            '&:focus::after': focuseEffect(),
        },

        [theme.breakpoints.down('sm')]: {
            rowGap: theme.spacing(2),
            '& .MuiBox-root': {
                width: '100%',
                '& .cstBtn': {
                    minWidth: '100%',
                },
            },
        },
    },
    '& .profile': {
        [theme.breakpoints.down('md')]: {
            textAlign: 'center',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            '& img': {
                width: theme.spacing(20),
                height: theme.spacing(20),
                borderRadius: '50%',
                boxShadow: '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
            },
        },
    },
    '& .cstEditProfile': {
        '& .MuiSelect-select': {
            paddingLeft: 0,
        },
        '& .MuiSelect-nativeInput': {
            background: 'transparent',
            border: 0,
            fontFamily: 'good_sansregular',
            color: getIconFill(theme),
        },
    },
    '& .cstSelectProfile': {
        '& .MuiInputLabel-root': {
            left: theme.spacing(-1.75),
            color: colors.placeholder,
            [theme.breakpoints.up('md')]: {
                top: theme.spacing(-2.375),
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: `1px solid ${colors.lightGray} !important`,
        },
        '&.cstState': {
            '& .MuiInputLabel-root': {
                top: theme.spacing(0),
            },
            '& .MuiInputBase-root,input': {
                paddingLeft: theme.spacing(0),
            },
        },
    },
    '& .cstProfileImage': {
        padding: theme.spacing(0, 3.75),
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        [theme.breakpoints.down('md')]: {
            margin: 'auto',
        },
        [theme.breakpoints.between(768, 1200)]: {
            padding: theme.spacing(0),
        },
        '& .cstProfileImageStack': {
            position: 'relative',
            '& .ReactCrop': {
                zIndex: 9,
            },
            '& img': {
                borderRadius: theme.spacing(2),
            },
            '& .cstProfileImageEdit': {
                position: 'absolute',
                inset: 0,
                display: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                '& input': {
                    display: 'none',
                },
                '&:hover': {
                    backdropFilter: ' brightness(0.4)',
                },
                '& .MuiIconButton-root': {
                    color: colors.white,
                },
            },
            '&:hover': {
                '& .cstProfileImageEdit': {
                    display: 'flex',
                    cursor: 'pointer',
                },
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
            '&.cstEmptyProfile': {
                height: '300px',
                minHeight: '360px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: theme.palette.mode === 'dark' ? colors.emptyImgageBg : colors.lightGray,
                borderRadius: theme.spacing(1),
                '& .emptyBox': {
                    width: theme.spacing(3.75),
                    '& img': {
                        borderRadius: 0,
                    },
                },
            },
        },
    },
    '& .contactUs': {
        '& .infoBox': {
            padding: theme.spacing(5),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            backgroundColor: theme.palette.mode === 'dark' ? colors.blackColor : colors.whiteSmoke,
            borderRadius: theme.spacing(1.25),
            '& .MuiTypography-root': {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                fontFamily: 'good_sansregular',
                '& .MuiLink-root': {
                    color: getIconFill(theme),
                    marginBottom: 0,
                    '&.cstLink': {
                        color: '#2FABE1',
                    },
                },
            },
        },
        [theme.breakpoints.down(1200)]: {
            flexDirection: 'column-reverse',
            '& .infoBox': {
                marginTop: theme.spacing(1.5),
                padding: theme.spacing(2),
                '& .MuiTypography-root': {
                    marginBottom: theme.spacing(1.5),
                },
            },
            '& img': {
                width: '35%',
            },
        },
        '& .cstHeaterName': {
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: getFieldSetColor(theme), // default border
                    borderBottomWidth: 2,
                },
                '&:hover fieldset': {
                    borderColor: getFieldSetColor(theme), // optional: hover color
                    borderBottomWidth: 2,
                },
                '&.Mui-focused fieldset': {
                    borderColor: getFieldSetColor(theme),
                    borderBottomWidth: 2,
                },
            },

            '& .MuiInputBase-input': {
                color: getIconFill(theme),
                '-webkit-text-fill-color': 'inherit',
            },
        },
    },
    '& .cstSlider': {
        '& .MuiSlider-root': {
            height: theme.spacing(1),
            background: getFieldSetColor(theme),
            padding: 0,
            margin: theme.spacing(2, 0),
            '& .MuiSlider-rail': {
                height: theme.spacing(0.5),
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 10%, #B3E3F3 20%, #FDCC3F 40%, #FF8524 60%, #E03C23 80%, #441212 100%)',
                opacity: 1,
                marginHorizontal: '5px',
            },
            '& .MuiSlider-track': {
                background: 'transparent',
                border: 'none',
            },
            '& .MuiSlider-mark': {
                background: 'transparent',
            },
            '& .MuiSlider-markLabel': {
                color: getIconFill(theme),
                top: theme.spacing(2.25),
                fontSize: theme.spacing(1),
                fontFamily: 'good_sansbold',
            },
            '& .MuiSlider-markLabel[data-index="0"]': {
                left: '2% !important',
            },
            '& .MuiSlider-markLabel[data-index="1"]': {
                left: '98% !important',
            },
            '& .MuiSlider-thumb': {
                background: 'linear-gradient(320.66deg, rgb(20, 21, 21) 14.75%, rgb(46, 50, 54) 84.81%)',
                boxShadow: 'none',
                '&:before': {
                    width: '40%',
                    height: '40%',
                    background: colors.SliderThumb,
                },
                '& .MuiSlider-valueLabelOpen': {
                    background: 'transparent',
                    padding: 0,
                    top: 0,
                    fontFamily: 'good_sansbold',
                    color: getIconFill(theme),
                },
            },
        },
    },
    '& .cstTextFeild': {
        position: 'relative',
        '& .MuiInputBase-root': {
            '& .MuiInputBase-input': {
                padding: theme.spacing(2.0625, 0),
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0px 0px 1px 0px',
                borderRadius: 0,
            },
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'none',
                },
            },
        },
        '& .cstEdit': {
            position: 'absolute',
            top: theme.spacing(5.875),
            right: 0,
        },
    },
    '& .cstModifyBtn': {
        fontSize: theme.spacing(1.25),
        background: getIconFill(theme),
        color: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
        padding: theme.spacing(0.375),
    },
    '& .cstActionBtns': {
        '& .cstBtnWrapper': {
            '& .MuiButtonBase-root': {
                padding: 0,
                zIndex: 1,
                '& .MuiStack-root': {
                    padding: theme.spacing(1.75, 2),
                    borderRadius: theme.spacing(2),
                    background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                    width: '100%',
                },
            },
            position: 'relative',
            padding: theme.spacing(0.125),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            borderRadius: theme.spacing(2),
            '&.cstActiveBtn': {
                height: '100%',
                '&::after': {
                    ...focuseEffect(),
                    zIndex: 0,
                    borderRadius: theme.spacing(2),
                },
                '& .active': {
                    color: colors.verifyText,
                },
            },
        },
    },
    '& .cstImgContainer': {
        position: 'relative',
        '&::after': {
            position: 'absolute',
            height: '100%',
            width: '100%',
            rotate: '180deg',
        },
    },
}));
export const NotifyContainer = styled(Stack)(({ theme }) => ({
    '& .cards': {
        borderRadius: theme.spacing(1),
        background: theme.palette.mode === 'dark' ? colors?.darkBgButton : colors?.whiteSmoke,
        '& .unread': {
            width: theme.spacing(1.75),
            height: theme.spacing(1.75),
            borderRadius: '50%',
            background: colors?.verifyText,
        },
        '& .MuiSvgIcon-root[data-testid="DeleteIcon"]': {
            color: colors?.astric,
        },
        '& .subText': {
            color: theme.palette.mode === 'dark' ? colors?.info : colors?.lightHead,
        },
    },
}));
